import { withChartLayout } from 'components/common';
import SleepDisorderScreening from 'components/features/chart/special-charts/sleep-disorder-screening/SleepDisorderScreening';

const SleepDisorderScreeningPage = withChartLayout('Sleep Disorder Screening')(SleepDisorderScreening);
export default SleepDisorderScreeningPage;
